import { View } from "binder"
import { ToolModelFromProducerEditorViewModel } from "./toolModelFromProducerEditor-viewModel"
import { ToolModelSelectorViewModel } from "../toolModelSelector-viewModel";
import { ToolProducerSelectorViewModel } from "../toolProducerSelector-viewModel";

export class ToolModelFromProducerEditorView extends View<ToolModelFromProducerEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-39BF6684-FC6C-4339-8AAD-1903784CC5EA"
    }
    loadHtml(): string {
        let element = require('./toolModelFromProducerEditor.html').default;
        let style = require('./toolModelFromProducerEditor.less');
        return element;
    }
    constructor() {
        super();
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set toolModelId(v: string) { this._toolModelId = v; } public get toolModelId(): string { return this._toolModelId; } private _toolModelId: string;
    public set toolModelSelector(v: ToolModelSelectorViewModel) { this._toolModelSelector = v; } public get toolModelSelector(): ToolModelSelectorViewModel { return this._toolModelSelector; } private _toolModelSelector: ToolModelSelectorViewModel;
    public set toolProducerId(v: string) { this._toolProducerId = v; } public get toolProducerId(): string { return this._toolProducerId; } private _toolProducerId: string;
    public set toolProducerSelector(v: ToolProducerSelectorViewModel) { this._toolProducerSelector = v; } public get toolProducerSelector(): ToolProducerSelectorViewModel { return this._toolProducerSelector; } private _toolProducerSelector: ToolProducerSelectorViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    back() {
        this.dataContext.back();
    }

    save() {
        this.dataContext.save();
    }
}
